import RouteTemplate from "ember-route-template";
import { htmlSafe } from "@ember/template";

export default RouteTemplate(
  <template>
    <div class="pd-reading-progress" id="reading-progress-bar"></div>

    <div class="pd-breadcrumbs">
      <a href="/">HOME</a>
      <span class="pd-breadcrumbs__sep">/</span>
      <a href="/guides">GUIDES</a>
      {{#if @controller.model.category}}
        <span class="pd-breadcrumbs__sep">/</span>
        <a href="/guides?category={{@controller.model.category}}">
          {{@controller.model.categoryUpper}}
        </a>
      {{/if}}
      <span class="pd-breadcrumbs__sep">/</span>
      <span>{{@controller.model.titleUpper}}</span>
    </div>

    <article class="pd-guide">
      <header class="pd-guide__hero">
        {{#if @controller.model.category}}
          <span class="pd-guide__category">
            {{@controller.model.categoryLabel}}
          </span>
        {{/if}}

        <h1 class="pd-guide__title">{{@controller.model.title}}</h1>

        <div class="pd-guide__meta">
          {{#if @controller.model.author.display_name}}
            <span class="pd-guide__meta-author">
              {{#if @controller.model.author.avatar_url}}
                <img
                  class="pd-guide__author-avatar"
                  src={{@controller.model.author.avatar_url}}
                  alt=""
                  width="28"
                  height="28"
                  loading="lazy"
                />
              {{/if}}
              By {{@controller.model.author.display_name}}
            </span>
          {{/if}}

          {{#if @controller.model.publishedLabel}}
            <span class="pd-guide__meta-date">
              Published {{@controller.model.publishedLabel}}
            </span>
          {{/if}}

          <span class="pd-guide__meta-readtime">
            {{@controller.model.read_time_minutes}} min read
          </span>

          {{#if @controller.model.freshness_grade}}
            <span class="pd-badge--freshness pd-badge--freshness-{{@controller.model.freshness_grade}}">
              {{@controller.model.freshnessGradeUpper}}
            </span>
          {{/if}}
        </div>
      </header>

      {{#if @controller.model.toc.length}}
        <div class="pd-guide__toc-mobile">
          <details class="pd-toc-box">
            <summary class="pd-toc-box__summary">
              <span>Table of Contents</span>
              <span class="pd-toc-box__icon">&#9660;</span>
            </summary>
            <ul class="pd-toc-box__list">
              {{#each @controller.model.toc as |item|}}
                <li class="pd-toc-box__item pd-toc-box__item--{{item.level}}">
                  <a href="#{{item.id}}">{{item.text}}</a>
                </li>
              {{/each}}
            </ul>
          </details>
        </div>
      {{/if}}

      <div class="pd-guide__body">
        <div class="pd-guide__main-content">
          <div class="pd-guide__content">
            {{htmlSafe @controller.model.content}}
          </div>

          {{#if @controller.model.faq_parsed.length}}
            <section class="pd-faq">
              <h2 class="pd-faq__title">Frequently Asked Questions</h2>
              <div class="pd-faq__list">
                {{#each @controller.model.faq_parsed as |item idx|}}
                  <div class="pd-faq__item" id="faq-item-{{idx}}">
                    <button
                      class="pd-faq__question"
                      aria-expanded="false"
                      type="button"
                    >
                      <span>{{item.q}}</span>
                      <span class="pd-faq__toggle-icon">&#9660;</span>
                    </button>
                    <div class="pd-faq__answer">
                      <p>{{item.a}}</p>
                    </div>
                  </div>
                {{/each}}
              </div>
            </section>
          {{/if}}

          <div class="pd-helpful-widget" id="guide-feedback-widget">
            <span class="pd-helpful-widget__question">
              Was this guide helpful?
            </span>
            <div class="pd-helpful-widget__actions">
              <button class="pd-helpful-widget__btn" id="feedback-yes-btn" type="button">
                Yes
              </button>
              <button class="pd-helpful-widget__btn" id="feedback-no-btn" type="button">
                No
              </button>
            </div>
            <span class="pd-helpful-widget__thanks" id="feedback-thanks-msg">
              Thanks for your feedback!
            </span>
            <span class="pd-helpful-widget__error" id="feedback-error-msg">
              Something went wrong. Please try again later.
            </span>
          </div>

          {{#if @controller.model.relatedComparisons.length}}
            <section class="pd-guide__related">
              <h3 class="pd-guide__related-title">Related Comparisons</h3>
              <div class="pd-guide__related-grid">
                {{#each @controller.model.relatedComparisons as |comp|}}
                  <a class="pd-related-card" href="/compare/{{comp.slug}}">
                    <h4 class="pd-related-card__title">{{comp.title}}</h4>
                    <p class="pd-related-card__summary">{{comp.summary}}</p>
                    <span class="pd-related-card__link">View comparison &rarr;</span>
                  </a>
                {{/each}}
              </div>
            </section>
          {{/if}}
        </div>

        {{#if @controller.model.toc.length}}
          <aside class="pd-guide__sidebar">
            <nav class="pd-toc-sidebar">
              <h4 class="pd-toc-sidebar__title">ON THIS PAGE</h4>
              <ul class="pd-toc-sidebar__list">
                {{#each @controller.model.toc as |item|}}
                  <li class="pd-toc-sidebar__item pd-toc-sidebar__item--{{item.level}}">
                    <a
                      href="#{{item.id}}"
                      class="pd-toc-sidebar__link"
                      data-toc-id="{{item.id}}"
                    >{{item.text}}</a>
                  </li>
                {{/each}}
              </ul>
            </nav>
          </aside>
        {{/if}}
      </div>
    </article>

    <button
      class="pd-back-to-top"
      id="back-to-top-btn"
      type="button"
      aria-label="Back to top"
    >&uarr;</button>
  </template>
);
